import React, { useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import LazyLoad from 'react-lazyload';
import SvgCircle from '../components/svgCircle';
import { useTranslation } from 'react-i18next';


const ScreenShot = () => {

	const [updater, setUpdater] = useState(1);

	const { t, i18n } = useTranslation();

	i18n.on('languageChanged', () => {
		setTimeout(() => setUpdater(updater + 1), 100)
	 })

	// OwlCarousel Option for Screenshot
	const options = {
		0: {
			items: 2,
			lazyLoadEager: 1
		},
		767: {
			items: 3,
			lazyLoadEager: 1
		},
		768: {
			items: 3,
			lazyLoadEager: 1
		},
		992: {
			items: 4,
			lazyLoadEager: 1
		},
		1200: {
			items: 5
		}
	};

	return (
		<section id="screenshot" className="screenshot padding-top-bottom">
			<div className="screenshot-decor">
				<div className="screenshot-circle1 circle-shadow">
					<SvgCircle id="screenshot-circle1" color1="#FA0A7F" color2="#FF5B89" r1="25" r2="7" />
					{/* 						<LazyLoad><img src="assets/images/feature-circle-two.png" alt="feature-circle-two" /></LazyLoad> */}
				</div>
				<div className="screenshot-circle2 circle-shadow">
					<SvgCircle id="screenshot-circle1" color1="#FA0A7F" color2="#FF5B89" r1="40" r2="10" />
					{/* 						<LazyLoad><img src="assets/images/feature-circle.png" alt="feature-circle" /></LazyLoad> */}
				</div>
				<div className="screenshot-circle3 circle-shadow">
					<SvgCircle id="screenshot-circle1" color1="#FA0A7F" color2="#FF5B89" r1="75" r2="52" />
					{/* 						<LazyLoad><img src="assets/images/main-banner1.png" alt="feature-circle-three" /></LazyLoad> */}
				</div>
			</div>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 ">
						<div className="screenshot-contain">
							<LazyLoad><img className="mobile-light-left" src="assets/images/light.png" alt="light" /></LazyLoad>
							<img className="mob-mocup img-fluid" src="assets/images/screenshot-mob.png" alt="screenshot-mob" />
							<LazyLoad><img className="mobile-light-right" src="assets/images/light-right.png" alt="light-right" /></LazyLoad>
							<OwlCarousel
								className="screenshot-carousel owl-carousel owl-theme"
								loop={true}
								lazyLoad={true}
								margin={30}
								items={3}
								center={true}
								dots={false}
								autoplay={true}
								autoplayTimeout={8000}
								responsive={options}
								startPosition={2}
							>

								<div className="screenshot-item"><img className="owl-lazy" data-src={`assets/images/app/${t('imagePrefix')}om-1.png`} alt="app" /></div>
								<div className="screenshot-item"><img className="owl-lazy" data-src={`assets/images/app/${t('imagePrefix')}om-2.png`} alt="app" /></div>
								<div className="screenshot-item"><img className="owl-lazy" data-src={`assets/images/app/${t('imagePrefix')}om-3.png`} alt="app" /></div>
								<div className="screenshot-item"><img className="owl-lazy" data-src={`assets/images/app/${t('imagePrefix')}om-4.png`} alt="app" /></div>
								<div className="screenshot-item"><img className="owl-lazy" data-src={`assets/images/app/${t('imagePrefix')}om-5.png`} alt="app" /></div>

							</OwlCarousel>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}


export default ScreenShot;


// WEBPACK FOOTER //
// ./src/components/screenshot.js